export enum DialogActionsEnum {
    Decline,
    Confirm,
    ProcessFinished
}
